import { render, staticRenderFns } from "./HighFrequencyStatusControl.vue?vue&type=template&id=288289f2&scoped=true"
import script from "./HighFrequencyStatusControl.vue?vue&type=script&lang=js"
export * from "./HighFrequencyStatusControl.vue?vue&type=script&lang=js"
import style0 from "./HighFrequencyStatusControl.vue?vue&type=style&index=0&id=288289f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288289f2",
  null
  
)

export default component.exports